import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const b64uToBuf = (s) => {
  const pad = '='.repeat((4 - (s.length % 4)) % 4);
  const bin = atob(s.replace(/-/g, '+').replace(/_/g, '/') + pad);
  const buf = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) buf[i] = bin.charCodeAt(i);
  return buf.buffer;
};

const bufToB64u = (buf) =>
  btoa(String.fromCharCode(...new Uint8Array(buf)))
    .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

export const isMobileDevice = () =>
  /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

export async function platformAuthAvailable() {
  try {
    return !!window.PublicKeyCredential &&
      await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
  } catch {
    return false;
  }
}

export async function passkeyStatus() {
  return (await axios.get(`${API}/auth/webauthn/status`, {
    params: { origin: window.location.origin },
  })).data;
}

export async function registerPasskey() {
  const { data: opts } = await axios.post(`${API}/auth/webauthn/register/options`,
    { origin: window.location.origin });
  const publicKey = {
    ...opts,
    challenge: b64uToBuf(opts.challenge),
    user: { ...opts.user, id: b64uToBuf(opts.user.id) },
    excludeCredentials: (opts.excludeCredentials || []).map(c => ({ ...c, id: b64uToBuf(c.id) })),
    hints: ['client-device'],
  };
  const cred = await navigator.credentials.create({ publicKey });
  const payload = {
    id: cred.id,
    rawId: bufToB64u(cred.rawId),
    type: cred.type,
    authenticatorAttachment: cred.authenticatorAttachment || null,
    clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
    response: {
      clientDataJSON: bufToB64u(cred.response.clientDataJSON),
      attestationObject: bufToB64u(cred.response.attestationObject),
      transports: cred.response.getTransports ? cred.response.getTransports() : [],
    },
  };
  await axios.post(`${API}/auth/webauthn/register/verify`, payload);
}

export async function resetPasskey() {
  return (await axios.post(`${API}/auth/webauthn/reset`,
    { origin: window.location.origin })).data;
}

export async function authenticatePasskey() {
  const { data: opts } = await axios.post(`${API}/auth/webauthn/authenticate/options`,
    { origin: window.location.origin });
  const publicKey = {
    ...opts,
    challenge: b64uToBuf(opts.challenge),
    allowCredentials: (opts.allowCredentials || []).map(c => ({ ...c, id: b64uToBuf(c.id) })),
  };
  const cred = await navigator.credentials.get({ publicKey });
  const payload = {
    id: cred.id,
    rawId: bufToB64u(cred.rawId),
    type: cred.type,
    authenticatorAttachment: cred.authenticatorAttachment || null,
    clientExtensionResults: cred.getClientExtensionResults ? cred.getClientExtensionResults() : {},
    response: {
      clientDataJSON: bufToB64u(cred.response.clientDataJSON),
      authenticatorData: bufToB64u(cred.response.authenticatorData),
      signature: bufToB64u(cred.response.signature),
      userHandle: cred.response.userHandle ? bufToB64u(cred.response.userHandle) : null,
    },
  };
  await axios.post(`${API}/auth/webauthn/authenticate/verify`, payload);
}

// Module-level unlock flag: survives SPA route changes, resets on reload / real app open.
let unlocked = false;
export const isUnlocked = () => unlocked;
export const setUnlocked = (v) => { unlocked = v; };
